import React from "react"
import PropTypes from "prop-types"
import { Modal, Button } from "components/common"
import { useDispatch } from "react-redux"
import { useForm, Controller } from "react-hook-form"
import { toast } from "react-toastify"
import { FaUserPlus } from "react-icons/fa"
import AsyncSelect from "react-select/async"
import { activeEmployeesByNameDebounce } from "helpers/employeeOptionHelper"
import { shareTemplatePolicy } from "redux/templatePoliciesSlice"

const TemplatePolicyAssignOwner = ({ show, onHide, asset, onSuccess }) => {
  const dispatch = useDispatch()
  const { control, handleSubmit, setValue, formState: { errors } } = useForm()

  const employeeOptions = (inputValue, callback) => {
    activeEmployeesByNameDebounce(inputValue, callback)
  }

  const handleChangeEmployee = (selectedOptions) => {
    setValue("employee_names", selectedOptions.map(o => o.value), { shouldValidate: true })
  }

  const onSubmit = (data) => {
    dispatch(shareTemplatePolicy({
      assetId: asset.id,
      data: { employee_names: data.employee_names }
    }))
      .unwrap()
      .then(() => {
        toast.success(`Owners assigned for "${asset.name}"`)
        onSuccess()
      })
      .catch((err) => {
        toast.error(err?.message || err?.error || "Failed to assign owners")
      })
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdropClick={false}
      title={(
        <>
          <FaUserPlus className="tw-mr-2 tw-text-blue-600" />
          Assign Owner — {asset?.name}
        </>
      )}
      footer={(
        <>
          <Button size="sm" variant="ghost" onClick={onHide}>
            Cancel
          </Button>
          <Button size="sm" variant="primary" type="submit" form="template-policy-assign-owner-form">
            <FaUserPlus className="tw-mr-1" /> Assign
          </Button>
        </>
      )}
    >
      <form id="template-policy-assign-owner-form" onSubmit={handleSubmit(onSubmit)}>
        <p className="tw-text-slate-500 tw-text-sm tw-mb-3">
          Selected employees will be granted <strong>edit and delete</strong> access to this document.
        </p>

        <label htmlFor="employee_names" className="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1">
          People
        </label>
        <Controller
          control={control}
          name="employee_names"
          rules={{ required: "Please select at least one person" }}
          render={() => (
            <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={employeeOptions}
              closeMenuOnSelect={false}
              placeholder="Search employees…"
              classNamePrefix="react-select"
              isMulti
              onChange={handleChangeEmployee}
            />
          )}
        />
        {errors.employee_names && (
          <span className="tw-text-red-600 tw-text-xs tw-mt-1 tw-block">{errors.employee_names.message}</span>
        )}
      </form>
    </Modal>
  )
}

TemplatePolicyAssignOwner.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  asset: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string
  }),
  onSuccess: PropTypes.func.isRequired
}

export default TemplatePolicyAssignOwner
